import { z } from "zod";

// WHY: the CSP forbids eval, so Zod must never probe `new Function` for its JIT; this runs before any schema exists.
z.config({ jitless: true });
